var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-social__item",on:{"click":function($event){$event.preventDefault();return _vm.loginWithFacebook.apply(null, arguments)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"list-social__link",attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("@assets/img/img_social_2.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }